// Module
var code = "<button class=\"kanban-item__name-content\"> Case Name </button>";
// Exports
export default code;